
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  PaymentDetailsComponent, BeneficiaryDetailsComponent, DependantHealthRecordsComponent,
  SubmitApplicationComponent
} from 'src/app/pages/after-apply';
import { ClearToApplyComponent } from './components/clear-to-apply/clear-to-apply.component';
import { HealthRecordsComponent } from './components/annuitant-health-records/health-records.component';
import { YourPersonalDetailsComponent } from 'src/app/pages/after-apply/components/your-personal-details/your-personal-details.component';
import { YourDependantDetailsComponent } from './components/your-dependant-details/your-dependant-details.component';
// tslint:disable-next-line:max-line-length
import { YourProductApplicationComponent } from './components/product-application/your-product-application/your-product-application.component';
import { ApplicationSummaryComponent } from './components/product-application/application-summary/application-summary.component';
import { YourPensionSavingsComponent } from './components/your-pension-savings/your-pension-savings.component';
import { CreateApplicationSubmittedCanDeativeatedGuardGuard } from './components/create-application-submitted-can-deativeated-guard.guard';
import { AuthGuardGuard } from '../../shared/guards/auth-guard.guard';
import { cmsServiceMapperResolver } from 'src/app/shared/services/api-services/cms-service-mapper.resolver';
import { UserLoginRequiredComponent } from './components/user-login-required/user-login-required.component';
import { YourLumpSumAllowancesComponent } from './components/your-lump-sum-allowances/your-lump-sum-allowances.component';
const userRoutes: Routes = [
  {
    path: 'user-login-required',
    component: UserLoginRequiredComponent,
    data: {
      title: 'User login Required'
    }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'clear-to-apply',
    component: ClearToApplyComponent,
    data: {
      title: 'Online Quote - Apply - Clear To Apply'
    }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-payment-details',
    component: PaymentDetailsComponent,
    data: {
      title: 'Online Quote - Apply - Payment Details'
    }
   //  canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-doctors-details',
    component: HealthRecordsComponent,
    data: {
      title: 'Online Quote - Apply - Medical Records'
    }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-dependants-doctors-details',
    component: DependantHealthRecordsComponent,
    data: {
      title: 'Online Quote - Apply - Dependant Medical Records'
    }
  },
  {
    path: 'your-personal-details',
    component: YourPersonalDetailsComponent,
    data: {
      title: 'Online Quote - Apply - Annuitant Details'
    }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-dependant-details',
    component: YourDependantDetailsComponent,
    data: {
      title: 'Online Quote - Apply - Dependant Details'
    }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-beneficiary-details',
    component: BeneficiaryDetailsComponent,
    data: {
      title: 'Online Quote - Apply - Beneficiary Details'
    }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'congratulations',
    component: SubmitApplicationComponent,
    // canActivate: [AuthGuardGuard],
    canDeactivate: [CreateApplicationSubmittedCanDeativeatedGuardGuard],
    data: {
      title: 'Online Quote - Apply - Congratulations'
    }
  },
  {
    path: 'your-product-application',
    component: YourProductApplicationComponent,
    data: {
      title: 'Online Quote - Apply - Confirm,Sign and Submit'
    },
    resolve: { cmsJson: cmsServiceMapperResolver }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-pension-savings',
    component: YourPensionSavingsComponent,
    data: {
      title: 'Online Quote - Apply - Pension Savings'
    },
    resolve: { cmsJson: cmsServiceMapperResolver }
    // canActivate: [AuthGuardGuard]
  },
  {
    path: 'your-lump-sum-allowances',
    component: YourLumpSumAllowancesComponent,
    data: {
      title: 'My Sample Data'
    }
    
  },

];

@NgModule({
  imports: [
    RouterModule.forChild(userRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AfterApplyRouteModule { }
